

<script>
import { onMount } from 'svelte'

async function loop(){

  await new Promise(resolve => setTimeout(resolve, 3000))
  loop()
}

  onMount(()=>{
  loop()
})

</script>

<svelte:options tag="loading-indicator"></svelte:options>

<div class="loading-btn">
  <span class="LoadingIndicator">
  </span>  
  <span class="LoadingText">
    Loading...
  </span>

</div>

<style>

.loading-btn {
      background: #00bf6f;
      border-color: #00bf6f;
      transition: all 0.2s ease-in-out;
      border-radius: 0.25rem;
      border: none;
      position: relative;
      color: #fff;
      font-family: "Karla-Bold", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      font-size: 0.75rem;
      font-weight: normal;
      line-height: 0.875rem;
      letter-spacing: 0.03188rem;
      padding: 0.6875rem 2rem;
      text-transform: uppercase;
      cursor: pointer;
      display: block;
      text-align: center;
    }

.LoadingIndicator {
  position: absolute;
  display: inline-block;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      border: 2px solid rgba(255, 255, 255, 0.2);
      border-top-color: rgba(255, 255, 255, 0.2);
      border-top-color: white;
      -webkit-animation: spin 1s infinite linear;
      animation: spin 1s infinite linear;
      position: relative;
      right: 5px;
}
.LoadingText {
  display: inline-block;
  position: relative;
  top: -4px;
}


@-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
</style>
